// import { api } from "../../Config/Api";

// export const getAnalyticsOverview = async () => {
//   const jwt = localStorage.getItem("jwt");

//   console.log("Admin analytics JWT exists:", !!jwt);

//   const response = await api.get("/api/admin/analytics/overview", {
//     headers: {
//       Authorization: `Bearer ${jwt}`,
//     },
//   });

//   console.log("Admin analytics API raw response:", response);

//   return response.data;
// };

// export const getAnalyticsFunnel = async () => {
//   const jwt = localStorage.getItem("jwt");

//   const response = await api.get("/api/admin/analytics/funnel", {
//     headers: {
//       Authorization: `Bearer ${jwt}`,
//     },
//   });

//   return response.data;
// };

// export const getTopProductsAnalytics = async () => {
//   const jwt = localStorage.getItem("jwt");

//   const response = await api.get("/api/admin/analytics/top-products", {
//     headers: {
//       Authorization: `Bearer ${jwt}`,
//     },
//     params: {
//       limit: 5,
//     },
//   });

//   return response.data;
// };

// export const getAnalyticsTrend = async () => {
//   const jwt = localStorage.getItem("jwt");

//   const response = await api.get("/api/admin/analytics/trend", {
//     headers: {
//       Authorization: `Bearer ${jwt}`,
//     },
//   });

//   return response.data;
// };


import { api } from "../../Config/Api";

export type AnalyticsDateParams = {
  startDate?: string;
  endDate?: string;
};

const getAuthHeaders = () => {
  const jwt = localStorage.getItem("jwt");

  return {
    Authorization: `Bearer ${jwt}`,
  };
};

export const getAnalyticsOverview = async (
  params?: AnalyticsDateParams
) => {
  const response = await api.get("/api/admin/analytics/overview", {
    headers: getAuthHeaders(),
    params,
  });

  return response.data;
};

export const getAnalyticsFunnel = async (
  params?: AnalyticsDateParams
) => {
  const response = await api.get("/api/admin/analytics/funnel", {
    headers: getAuthHeaders(),
    params,
  });

  return response.data;
};

export const getTopProductsAnalytics = async (
  params?: AnalyticsDateParams
) => {
  const response = await api.get("/api/admin/analytics/top-products", {
    headers: getAuthHeaders(),
    params: {
      ...params,
      limit: 10,
    },
  });

  return response.data;
};

export const getAnalyticsTrend = async (
  params?: AnalyticsDateParams
) => {
  const response = await api.get("/api/admin/analytics/trend", {
    headers: getAuthHeaders(),
    params,
  });

  return response.data;
};

export const getAnalyticsTrendByDevice = async (
  deviceType: "MOBILE" | "DESKTOP",
  params?: AnalyticsDateParams
) => {
  const response = await api.get("/api/admin/analytics/trend/device", {
    headers: getAuthHeaders(),
    params: {
      ...params,
      deviceType,
    },
  });

  return response.data;
};